"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const utils_1 = require("../utils");
const buttons_1 = require("../buttons");
const react_if_1 = require("react-if");
exports.OsmosysFlexFrame = ({ children, bg, shadow, border, borderLeft, borderRight, borderBottom, borderTop, style, className, }) => {
    return (react_1.default.createElement(utils_1.OsmosysDiv, { osysName: "OsmosysFlexFrame", className: [
            'h-100',
            'w-100',
            'overflow-hidden',
            'flex-shrink-0',
            className,
        ], bg: bg, flexColFilled: true, shadow: shadow, border: border, borderLeft: borderLeft, borderRight: borderRight, borderBottom: borderBottom, borderTop: borderTop, style: style },
        react_1.default.createElement(utils_1.OsmosysDiv, { osysName: "OsmosysFlexFrame.Inner", className: ['overflow-hidden'], flexColFilled: true }, children)));
};
exports.OsmosysFlexFrame.Row = ({ children, fixedHeight, scroll, shadow, borderBottom, className, padding, innerClassName, style, }) => {
    return (react_1.default.createElement(utils_1.OsmosysDiv, { osysName: "OsmosysFlexFrame.Row", className: [
            'overflow-hidden',
            fixedHeight ? 'flex-col flex-shrink-0' : 'flex-full-col',
            borderBottom && 'border-bottom',
            className,
        ], shadow: shadow, style: Object.assign({ zIndex: shadow ? 1 : 0 }, style) },
        react_1.default.createElement(utils_1.OsmosysDiv, { osysName: "OsmosysFlexFrame.Row.Inner", padding: padding, flexRowFilled: true, className: [
                scroll ? 'overflow-y-auto' : 'overflow-hidden',
                innerClassName,
            ] }, children)));
};
exports.OsmosysFlexFrame.Toolbar = (_a) => {
    var { children, className } = _a, props = tslib_1.__rest(_a, ["children", "className"]);
    return (react_1.default.createElement(exports.OsmosysFlexFrame.Row, Object.assign({ osysName: "OsmosysFlexFrame.Toolbar", shadow: true, fixedHeight: true, borderBottom: true }, props, { className: ['bg-white', className] }), children));
};
exports.OsmosysFlexFrame.ToolbarButton = (_a) => {
    var { padding = false, margin } = _a, props = tslib_1.__rest(_a, ["padding", "margin"]);
    return (react_1.default.createElement(exports.OsmosysFlexFrame.ToolbarCell, { osysName: "OsmosysFlexFrame.ToolbarButton", padding: padding, flexColCentered: true, margin: margin },
        react_1.default.createElement("div", null,
            react_1.default.createElement(buttons_1.OsmosysButton, Object.assign({ osysStyle: "toolbar" }, props)))));
};
exports.OsmosysFlexFrame.ToolbarGroup = (_a) => {
    var { children } = _a, props = tslib_1.__rest(_a, ["children"]);
    return (react_1.default.createElement(exports.OsmosysFlexFrame.ToolbarCell, Object.assign({ osysName: "OsmosysFlexFrame.ToolbarGroup", flexRow: true, padding: false }, props), children));
};
exports.OsmosysFlexFrame.ToolbarCell = (_a) => {
    var { children, heading, margin, className } = _a, props = tslib_1.__rest(_a, ["children", "heading", "margin", "className"]);
    return (react_1.default.createElement(utils_1.OsmosysDiv, Object.assign({ osysName: "ToolbarCell" }, props, { className: [className, margin && 'mx-1'] }),
        react_1.default.createElement(react_if_1.Switch, null,
            react_1.default.createElement(react_if_1.Case, { condition: !!heading },
                react_1.default.createElement("p", { className: "mb-0 lead font-weight-bold" }, children)),
            react_1.default.createElement(react_if_1.Default, null, children))));
};
exports.OsmosysFlexFrame.Col = (_a) => {
    var { children, maxWidth, padding, className, noOverflowY } = _a, props = tslib_1.__rest(_a, ["children", "maxWidth", "padding", "className", "noOverflowY"]);
    return (react_1.default.createElement(utils_1.OsmosysDiv, Object.assign({ osysName: "OsmosysFlexFrame.Col", padding: padding, style: {
            maxWidth,
        } }, props, { className: [
            'overflow-hidden',
            'flex-full-col',
            'flex-basis-0',
            className,
        ] }),
        react_1.default.createElement(utils_1.OsmosysDiv, { osysName: "OsmosysFlexFrame.Col.Inner", className: [
                noOverflowY ? 'overflow-hidden' : 'overflow-y-auto',
                'flex-full-col',
            ] }, children)));
};
//# sourceMappingURL=OsmosysFlexFrame.js.map